import { render, staticRenderFns } from "./ImpactEntryFromRequirementViewPart.vue?vue&type=template&id=261ec11b&scoped=true&"
import script from "./ImpactEntryFromRequirementViewPart.vue?vue&type=script&lang=ts&"
export * from "./ImpactEntryFromRequirementViewPart.vue?vue&type=script&lang=ts&"
import style0 from "./ImpactEntryFromRequirementViewPart.vue?vue&type=style&index=0&id=261ec11b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261ec11b",
  null
  
)

export default component.exports